import React from 'react';
import { NeighborhoodPriceData } from '../../types';
import { useFilters } from '../../cube/filters';
import { D3HorizontalBarChart } from './D3HorizontalBarChart';

interface BarChartProps {
  data: NeighborhoodPriceData[];
  colorScaleFunc?: (value: number) => string;
}

export const BarChart: React.FC<BarChartProps> = ({ data, colorScaleFunc }) => {
  const { filters, set } = useFilters();
  const selected = filters.bairros || [];
  
  const series = (data || []).map((d) => ({
    key: d.neighborhood,
    value: Number(d.median_price_per_m2),
    color: colorScaleFunc ? colorScaleFunc(Number(d.median_price_per_m2)) : '#2563eb'
  })).sort((a, b) => b.value - a.value);

  return (
    <D3HorizontalBarChart
      data={series}
      title={`Todos os Bairros por Preço por m² (${series.length} total)`}
      xLabel="Preço por m² (R$)"
      selectedKeys={selected}
      onBarClick={(key) => {
        const k = String(key);
        const active = selected.includes(k);
        set({ bairros: active ? undefined : [k] });
      }}
      formatX={(n) => `R$${Math.round(n)}`}
      formatKey={(k) => String(k)}
      highlightTopN={0}
    />
  );
};
